/*********************************************************************
 * jqDialog.js
 * *******************************************************************
 * This script implements the widget Dialog of Jquery UI library which is documented in detail in
 * http://jqueryui.com/demos/dialog/
 * A dialog is a floating window that contains a title bar and a content area.
 * ******************************************************************* */

var isjqDialogContentLoading = true;

/**
 * This function initializes a dialog instance.
 * @param idDialog: the dialog id.
 * @param dHandlerSync: number to indicate 0: nessun dHandler; 1: dHandler sync: 2: dHandler async
 * @param nameFunBeforeClose: the name of the function which is called before the dialog is closed
 * @param nameFunClose: the name of the function which is called when the dialog is closed
 * @param nameFunOKBtn: the name of the function which is called when the OK button is pressed
 * @param cancelButton: true/false/string value, to show/hiede cancel button or define a custom function
 * @param nameFunClickOutside: : the name of the function which is called when click outside a modal dialog
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param width: The width of the dialog, in pixels
 * @param height: The height of the dialog, in pixels
 * @param posX: an x coordinate in pixel offset from left corner of viewport
 * @param posY: an y coordinate in pixel offset from top corner of viewport
 * @param isModal: true/false, this allows you to create dialog which 'dim' the rest of the page when shown.
 * @param isDraggable: If set to true, the dialog will be draggable will be draggable by the titlebar
 * @param isResizable: If set to true, the dialog will be resizeable.
 * @param content: text/HTML which will appear inside the dialog initially
 * @param jqLoadingMessage: loading message (text/HTML).
 * @winRef the window from which the dialog was opened
 */
function createJQDialog (idDialog, dHandlerSync, nameFunBeforeClose, nameFunClose, nameFunOKBtn,
		cancelButton, nameFunClickOutside, title, width, height, posX, posY, isModal, isDraggable,
		isResizable, content, jqLoadingMessage, canMinimize, canMaximize, labelOk, labelCanc, alreadyExist, isAutoHeight, isMaximized, infiniteScroll, winRef, contentCssClass,
		resizeStartCallback, resizeStopCallback, maximizeCallback, restoreCallback) {
	isjqDialogContentLoading = true;

	var jqDialog = alreadyExist?$("#" + idDialog):rootPage.getJQDialog(idDialog, infiniteScroll);

	if(jqDialog.parent().hasClass("minimized") || jqDialog.parent().hasClass("maximized")){
		jqDialog.dialogExtend("restore");
	}

	// Declaration of the functions names
	jqDialog.data("nameFunBeforeClose", nameFunBeforeClose);
	jqDialog.data("nameFunClose", nameFunClose);
	jqDialog.data("nameFunOKBtn", nameFunOKBtn);
	jqDialog.data("cancelButton", cancelButton);
	jqDialog.data("nameFunClickOutside", nameFunClickOutside);

	var canUserMinimized, canUserMaximized;

	if(!ENV_VARS.isOnSmartphoneDevice()){
		// mimize and maximize, allways if resizable
		canUserMinimized = (isResizable)? true : canMinimize;
		canUserMaximized = (isResizable)? true : canMaximize;
	}
	else{
		/* Override dei parmateri di setup della dialog :
		 * Se il device è uno smartphone l'utente visualizzerà la dialog sempre Massimizzata e non avrà la possibilità
		 * di minimizzarla/massimizzarla/ridimensianarla/draggarla
		 */
		canUserMinimized = false;
		canUserMaximized = false;
		isMaximized	= true;
		isResizable = false;
		isDraggable = false;
	}

	//########### Local Method For Drag and Resize event on dialog #####
	function startEvent() {
		//Inside dialog
		var objIframe = $('iframe', jqDialog);

		if (objIframe.size()>0) {
			var d = jqDialog.data("tempDiv");

			if(!isDefined(d)){
				d = $('<div></div>');

				jqDialog.append(d[0]);

				d[0].id = 'temp_div';
				d.css({position:'absolute'});
			}

			d.css({
				top		: 	objIframe.position().top,
				left	:	objIframe.position().left,
				height	: 	objIframe.height(),
				width	: 	objIframe.width()
			});

			jqDialog.data("tempDiv", d);
		}
		//Outside dialog
		if(!isModal && !isDefined(jqDialog.data("dialogBackgroundDiv"))){
			var zIndex = parseInt(jqDialog.parent().css('z-index'));
			var container = rootPage.$('body');
			var $div = $("<div class='ui-widget-overlay'></div>").appendTo(container);
			$div.css({
					  'z-index': zIndex-1
					 ,'opacity': 0
					 });
			jqDialog.data('dialogBackgroundDiv', $div);
		}
	}

	function stopEvent() {
		//Inside dialog
		var tempDiv = jqDialog.data("tempDiv");
		if (tempDiv && tempDiv.size()>0){
			tempDiv.remove();
			jqDialog.removeData("tempDiv");
		}
		//Outside dialog
		var $div = jqDialog.data('dialogBackgroundDiv');
		if($div && $div.length>0){
			$div.remove();
			jqDialog.removeData("dialogBackgroundDiv");
		}
	}
	//########### END Local Method For Drag and Resize event on dialog #####

	var hideEventOnJqDialog = null;

	if (!$.browser.msie) {
		hideEventOnJqDialog = {
				effect: "fade",
				duration: "fast"
		};
	}


	// Initialization of basic feature
	jqDialog.dialog({
		autoOpen: false,
		modal:isModal,
		show: {effect: 'fade', duration: 'normal'},
		hide: hideEventOnJqDialog,
		content: content,
		dialogClass : "dcyJqDialog",
		beforeClose: function(event, ui) {
			var beforeCloseAction = jqDialog.data("nameFunBeforeClose");
			if (beforeCloseAction!=null && beforeCloseAction != "") {
				var result = executeFunctionByName(beforeCloseAction);
				if (result == false)
					return false;
			}

			var windowPage = rootPage.getWindowReferenceFromRootPage(idDialog),
				$body = $(windowPage.document.body),
				overflow = $body.data('overflow');

			$body.removeData('overflow');
			$body.css('overflow', overflow ? overflow : 'visible');

			$(windowPage.document.body).children().each(function(){
				var overflow = $(this).data('overflow');
				$(this).removeData('overflow');
				this.style.overflow = overflow ? overflow : 'visible';
			});
		},
		close: function(event, ui) {
			if(ENV_VARS.isOnTouchDevice() && $.browser.webkit)
				$(window).off('resize.' + idDialog);
			closureAction(idDialog, alreadyExist);
		},
		open: function(){
			var windowPage = winRef!=null && winRef!="" ? winRef : window;

			rootPage.saveWindowReferenceInRootPage(idDialog, windowPage);

			$(windowPage.document.body).data('overflow', $(windowPage.document.body).css('overflow'));
			windowPage.document.body.style.overflow = 'hidden';

			$(windowPage.document.body).children().each(function(){
				$(this).data('overflow', $(this).css('overflow'));
				this.style.overflow = 'hidden';
			});

			if (!isModal){
				rootPage.$(document).on('click.outside', function(e){
					if (e.target != "" && rootPage.$(e.target).parents().filter('.ui-dialog').length==0) {
						var result = executeFunctionByName(jqDialog.data("nameFunClickOutside"));
						if (result == false)
							return false;
			        }
				});
			}
			else{
				if(ENV_VARS.isOnTouchDevice() && $.browser.webkit) {
					//###############################################################
					//# Work-around for manage webkit bug scroll on dialog	#108408 #
					//###############################################################
					$(this).on('touchstart.modalDialogManage', function(event){
						var originalEvent = event.originalEvent;
						// Check if can scroll
					    this.allowUp = (this.scrollTop > 0); //Get the current vertical position of the scrollbar -> if the scrollBar is at the top, or if the element is not scrollable, this number will be 0.
					    this.allowDown = (this.scrollTop < this.scrollHeight - this.clientHeight); // If scroll to down
					    this.lastY = originalEvent.pageY; //Get the position finger on the screen
					});

					$(this).on('touchmove.modalDialogManage', function(event){
						var originalEvent = event.originalEvent;
						//Controll if touchMove is started with one finger
						if(originalEvent.touches.length > 1){
							return;
						}
						//If move to up or to down
					    var up = (originalEvent.pageY > this.lastY),
					        down = !up;
					    //Save last position finger
					    this.lastY = originalEvent.pageY;
					    //If can't move to up and down stop all successive event
					    if (!(up && this.allowUp) && !(down && this.allowDown)) {
					    	originalEvent.preventDefault();
					    }
					});

					$(rootPage).on('touchmove.modalDialogManage',function(event) {
						var originalEvent = event.originalEvent;
						if (originalEvent.target.classList.contains('ui-widget-overlay') && originalEvent.touches.length == 1){
							originalEvent.preventDefault();
						}
					});
					//###################################################################
					//# END Work-around for manage webkit bug scroll on dialog	#108408 #
					//###################################################################
				}
			}

			if(ENV_VARS.isOnTouchDevice() && $.browser.webkit) {
				$(window).off('resize.' + idDialog);
				$(window).on('resize.' + idDialog, function () {
					if (isMaximized && jqDialog)
						setTimeout(function(){
							setJQDialogHeight(jqDialog, "99%");
						});
				});
			}

			if(isAutoHeight){
				jqDialog.height("auto");
				$(this).css("max-height", height);
				$(this).css("max-width", width);
			}

			if (content.toLowerCase().indexOf("<iframe")==0) {
				var $tempElementContent = $(content);
				if(isDefined($tempElementContent) && isDefined($tempElementContent.get(0)) && $tempElementContent.get(0).tagName == 'IFRAME'){
					$(this).css('-webkit-overflow-scrolling','touch');
				}
			}

			if(isResizable){
				var sidesElement = $('.ui-resizable-handle',jqDialog.parent());

				sidesElement.on('mousedown',function(){
					startEvent();
				}).on('mouseup',function(){
					stopEvent();
				});

				jqDialog.parent().resizable({
					handles: "n, e, s, w, se, sw, nw, ne",
					start: function(){
						startEvent();
						isDefined(resizeStartCallback) && typeof resizeStartCallback === 'function' ? resizeStartCallback() : null;
					},
					resize: function(){
						startEvent();
					},
					stop: function(){
						stopEvent();
						isDefined(resizeStopCallback) && typeof resizeStopCallback === 'function' ? resizeStopCallback() : null;
					}
				});
			}

			if(isDraggable){
				jqDialog.parent().draggable({
					start: function(){
						startEvent();
					},
					stop: function(){
						stopEvent();
					}
				});
			}

			if( contentCssClass ) {
				jqDialog.addClass( contentCssClass );
			}
        }
	});




	jqDialog.parent().css("min-width", 100);

	// Setting options
	setJQDialogOptions(idDialog, title, width, height, posX, posY, isModal, isDraggable, isResizable);

	// Setting content
	if (content!=null && content!="")
		setContent(idDialog, content, dHandlerSync, jqLoadingMessage);

	// Initializing buttons
	setJQDialogButtons(idDialog, labelOk, labelCanc);

	openJQDialog(idDialog);

	extendJqDialog(jqDialog, canUserMaximized, canUserMinimized, isMaximized, maximizeCallback, restoreCallback);

	if (!$.browser.msie) {
		if (isModal) {
			jqDialog.dialog("widget").addClass("widgetModalCustomization");
			TdToReset.isTdToReset = false;
		} else {
			jqDialog.dialog("widget").addClass("widgetCustomization");
		}
	}

	return false;
};

/**
 * This method is used for extend jqdialog
 * @param $jqDialog
 * @param canMaximize
 * @param canMinimize
 * @param isMaximized
 */
function extendJqDialog($jqDialog, canMaximize, canMinimize, isMaximized, maximizeCallback, restoreCallback){
	if(dialogExists($jqDialog)){

		//Forced type of close button to button value
		$jqDialog .dialog("widget") .find(".ui-dialog-titlebar .ui-dialog-titlebar-close")
									.attr("type","button");

		isDefined(maximizeCallback) && typeof maximizeCallback === 'function' ? null : maximizeCallback = null;
		isDefined(restoreCallback) && typeof restoreCallback === 'function' ? null : restoreCallback = null;

		$jqDialog.dialogExtend({
			"maximizable" : canMaximize,
			"minimizable" : canMinimize,
			"isMaximized" : isMaximized,
			"maximize" 	  : maximizeCallback,
			"restore"     : restoreCallback
		});
	}
}


/**
 * Returns the widget dialog.
 * Create the dialog if it does not exist.
 * @param idDialog: the dialog id.
 */
function getJQDialog(idDialog, infiniteScroll)
{
	var $dialog = rootPage.$("#"+idDialog);
	destroyJQDialog($dialog, idDialog);

	var bodyInParentWin = rootPage.$('body');
	$dialog = $('<div id="'+idDialog+'"></div>').appendTo(bodyInParentWin);

	if (isDefined(infiniteScroll) && infiniteScroll) {
		$dialog.addClass("infiniteScrollTarget");
	}

	return $dialog;
};


/**
 * Sets the dialog content.
 * @param idDialog: the dialog id.
 * @param content: text/HTML which will appear inside the dialog initially.
 * @param dHandlerSync: number to indicate 0: nessun dHandler; 1: dHandler sync: 2: dHandler async
 * @param jqLoadingMessage: loading message (text/HTML)
 */
function setContent(idDialog, dContent, dHandlerSync, jqLoadingMessage){
	if (dHandlerSync != 0){	//html statico
		if (dHandlerSync == 2){//asincrono
			if (isjqDialogContentLoading){
				var timeDialog = window.setTimeout(
					function(){
						if (isjqDialogContentLoading)
							setJQDialogContent(idDialog, getJqContentForLoading(jqLoadingMessage));
					}
					,500
				);
			}
		}
		executeFunctionByName(dContent); //call the dynamic handler to update the dialog content
	}else{
		setJQDialogContent(idDialog, dContent);
	}
};

/**
 * Opens/shows the dialog.
 * @param idDialog: the dialog id.
 */
function openJQDialog(idDialog){
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog))
		jqDialog.dialog('open');
};

/**
 * Closes/destroys the dialog.
 * @param idDialog: the dialog id.
 */
function closureAction(idDialog, alreadyExist) {
	isjqDialogContentLoading = true;
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog)){
		TdToReset.isTdToReset = true;
		//eliminato jqDialog.parent().hide("fold"... poiché in alcuni casi non toglieva il loading
		//eliminato anche jqDialog.parent().fadeOut("fast" poichè troppo lento su ie10 e in alcuni casi
		//dopo la scomparsa della dialog restava il div opaco di loading e restituiva il seguente errore:
		//Impossibile eseguire il codice da uno script liberato jquery-1.9.1.js > Line Number: 9285
//		jqDialog.parent().fadeOut($.browser.msie?1:"fast", function() {
			var nameFunClose = jqDialog.data("nameFunClose");
			if (!alreadyExist){
				//richiamato col setTimeout per problema su ie11 T#109815
				setTimeout(function() {
					destroyJQDialog(jqDialog, idDialog);
				}, 0);
			}
			if (nameFunClose!=null && nameFunClose != ""){
				//richiamato col setTimeout per problema su ie9
				$(document).ready(function() {
					executeFunctionByName(nameFunClose);
				});
			}
//		});

		rootPage.$(document).off('click.outside');

		//###############################################################
		//# Work-around for manage webkit bug scroll on dialog	#108408 #
		//###############################################################
		//Unbind modalDialog Manage Handler
		jqDialog.off('touchstart.modalDialogManage');
		jqDialog.off('touchmove.modalDialogManage');
		$(rootPage).off('touchmove.modalDialogManage');
		//###################################################################
		//# END Work-around for manage webkit bug scroll on dialog	#108408 #
		//###################################################################
	}
};


function closeJQDialog(idDialog, runBeforeCloseFunction) {
	if(ENV_VARS.isOnTouchDevice() && $.browser.webkit)
		$(window).off('resize.' + idDialog);
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog)){
		if (!runBeforeCloseFunction) {
			jqDialog.data("nameFunBeforeClose", "");
		}
		jqDialog.dialog("close");		
	}
};

/**
 * Sets the beforeClose and close event handlers.
 * @param idDialog: the dialog id.
 * @param nameFunBeforeClose: the name of the function which is called before the dialog is closed
 * @param nameFunClose: : the name of the function which is called when the dialog is closed
*/
function setJQDialogClosure (idDialog, nameFunBeforeClose, nameFunClose){
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog)){
		jqDialog.data("nameFunBeforeClose", nameFunBeforeClose);
		jqDialog.data("nameFunClose", nameFunClose);
	}
};

/**
 * Set the data for ok and canc function and refresh the buttons
 * @param idDialog
 * @param nameFunOKBtn
 * @param cancelButton
 */
function setJQDialogButtonActions (idDialog, nameFunOKBtn, cancelButton) {
	var jqDialog = rootPage.$('#'+idDialog);
	jqDialog.data("nameFunOKBtn", nameFunOKBtn);
	jqDialog.data("cancelButton", cancelButton);
	setJQDialogButtons(idDialog);
}

/**
 * Sets the dialog buttons.
 * @param idDialog: the dialog id.
 * @param labelOk: label of Ok Button
 * @param labelCanc: label of Canc Button
 */
function setJQDialogButtons (idDialog, labelOk, labelCanc, classOK, classCancel, customCloseOnOK){
	var jqDialog = rootPage.$('#'+idDialog);
	var dButtons = [];
	if (labelOk == null) labelOk = (typeof LANGUAGES != 'undefined')?LANGUAGES.getOriginalLabel("jqdialogDefOkBtn"):"Ok";
	if (labelCanc == null) labelCanc = (typeof LANGUAGES != 'undefined')?LANGUAGES.getOriginalLabel("jqdialogDefCancelBtn"):"No";
	if (dialogExists(jqDialog)){
		var nameFunOKBtn = jqDialog.data("nameFunOKBtn");
		var cancelButton = jqDialog.data("cancelButton");
		if (nameFunOKBtn != null && nameFunOKBtn != ""){
			dButtons.push({
				text: labelOk,
				"class" : (classOK != null) ?  classOK : "",
				click: function() {
					var result = executeFunctionByName(nameFunOKBtn);

					if(customCloseOnOK)
						return false;

					if (result == false)
						return false;

					if(dialogExists(jqDialog)){
						jqDialog.dialog("close");
					}
				}
			 });
		}
		if (cancelButton != false && cancelButton != "false"){
			dButtons.push({
				text: labelCanc,
				"class" : (classCancel != null) ?  classOK : "",
				click: function() {
					if (cancelButton != true && cancelButton != "true" && cancelButton != ""){
						var result = executeFunctionByName(cancelButton);
						if (result == false)
							return false;
					}
					if(dialogExists(jqDialog)){
						jqDialog.dialog("close");
					}
				}
			 });
		}
		if (dButtons.length>0)
			jqDialog.dialog("option", "buttons", dButtons);
	}
};

/**
 * Sets the dialog content.
 * @param idDialog: the dialog id.
 * @param content: text/HTML which will appear inside the dialog initially.
 */
function setJQDialogContent(idDialog, dContent){
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog))
		jqDialog.get(0).innerHTML = replaceAll(dContent, "<SEP_PARAM>","\'");
		//jqDialog.html(replaceAll(dContent, "<SEP_PARAM>","\'"));
};

function setJQDialogDataValue(idDialog, data, value){
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog))
		jqDialog.data(data, value);
};

function getJQDialogDataValue(idDialog, data){
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog))
		return jqDialog.data(data);
	return null;
};

/**
 * Sets the dialog options (title, size, position, modal, draggable, resizable).
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param width: The width of the dialog, in pixels
 * @param height: The height of the dialog, in pixels
 * @param posX: an x coordinate in pixel offset from left corner of viewport
 * @param posY: an y coordinate in pixel offset from top corner of viewport
 * @param isModal: true/false, this allows you to create dialog which 'dim' the rest of the page when shown.
 * @param isDraggable: If set to true, the dialog will be draggable will be draggable by the titlebar
 * @param isResizable: If set to true, the dialog will be resizeable.
 */
function setJQDialogOptions (idDialog, title, width, height, posX, posY, isModal, isDraggable, isResizable){
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog)){
		jqDialog.dialog("option", "title", title);
		setJQDialogWidth(jqDialog, width);
		setJQDialogHeight(jqDialog, height);
		if (parseInt(posX) >= 0 && parseInt(posY) >= 0)
			jqDialog.dialog("option", "position",  { my: "left top", at: "left+"+posX+" top+"+posY});
		jqDialog.dialog("option", "modal", isModal);
		jqDialog.dialog("option", "draggable", isDraggable);
		jqDialog.dialog("option", "resizable", isResizable);
		jqDialog.dialog("option", "bgiframe", true);
	}
};

/**
 * Returns the dialog content for loading message
 * @param jqLoadingMessage: loading message (text/HTML)
 */
function getJqContentForLoading(jqLoadingMessage){
	jqLoadingMessage = (jqLoadingMessage!="" && jqLoadingMessage!=undefined) ? replaceAll(jqLoadingMessage, "<SEP_PARAM>","\'"):"";
	return "<div class='loadSmallImg'/><span class='jqLoadingMessage'>"+jqLoadingMessage+"</span></div>";
};

/**
 * Executes the function in input
 * @param functionName: the function name
 */
function executeFunctionByName(functionName) {
	if (typeof functionName == "function")
		return functionName();
	//var tmpFunc = new Function(replaceAll(functionName, "<SEP_PARAM>","\'"));
	//return tmpFunc();
	return eval(replaceAll(functionName, "<SEP_PARAM>","\'"));
};

 /**
  * Setting the function name for customize click outside the open dialog non modal.
  * @param idDialog: the dialog id.
  */
 function setJQDialogClickOutside(idDialog){
	 var jqDialog = rootPage.$('#'+idDialog);
	 if (dialogExists(jqDialog))
		 jqDialog.data("nameFunClickOutside", nameFunClickOutside);
 };

 /**
  * Used by dynamic handler to update the dialog content after an asynchronous HTTP (Ajax) request.
  * @param idDialog: the dialog id.
  * @param content: text/HTML which will appear inside the dialog initially.
  */
 function setJQDialogContentByDHandler(idDialog, contentFrom, content){
	 var jqDContent = content;
	 if (contentFrom=="JS_HANDLER"){
		 jqDContent = executeFunctionByName(content);
	 }
	setJQDialogContent(idDialog, jqDContent);
	isjqDialogContentLoading = false;
};

/**
 * Create a modal and draggable dialog with a simple message.
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML which will appear inside the dialog.
 */
function JQAlert(idDialog, title, message, width, height, callback, resizable) {
	if(width == null) width="";
	if(height == null) height="";
	if (!callback)
		callback = "";
	if (!resizable)
		resizable=false;
	createJQDialog(idDialog, 0, callback, "", function(){}, false, "", title, width, height, "", "", true, true, resizable, message, "", false, false);
};

function JQAlertWithTmpl(idDialog, title, width, height, maxWidth, maxHeight, callback, resizable, jsonData, template) {

	JQAlert(idDialog, title, "", width, height, callback, resizable);
	jsonData.view = template;
	decorateContentToSelector(jsonData, "#" + idDialog);

	var $dialog = $("#" + idDialog);

	//Va specificata la radice decimale nella funzione parseInt per Ie8 che usa la radice ottale di default #111924.
	if (maxWidth!=null)
		$dialog.css("max-width", parseInt("0" + maxWidth, 10) + "px");
	if (maxHeight!=null)
		$dialog.css("max-height", parseInt("0" + maxHeight, 10) + "px");

	$dialog.dialog({ position: 'center' });

};

/**
 * Returns the message in input decorated with an image according to the message type (alert, warning, error, info, question).
 * @param message: text/HTML which will appear inside the dialog.
 * @param iconClass: the icon name to message decorating
 */
function getDecoratedAlertMsg(message, iconClass) {
	var errMsg = "<table class='tblMessage'><tr>";
	if (iconClass != null && iconClass != "<NO_ICON>")
		errMsg += "<td valign='top'><span class='"+iconClass+"'></span></td>";
	errMsg += "<td><span class='msgDecorationText'>"+message+"</span></td>";
	errMsg += "</tr></table>";
	return errMsg;
};


/**
 * Return the message decorated by the icon type, a numeric value to indicare type of message
 * @param message: text/HTML which will appear inside the dialog.
 * @param iconType: (numeric) icon type (0: no icon, 1: info icon, 2: warning icon, 3: error icon)
 * @param defaultIconType: (numeric) default icon type, if iconType valure is incorrect
 * @returns
 */
function getDecoratedMessage(message, iconType, defaultIconType) {
	var iconTypes = {
			0:"<NO_ICON>",
			1:"de_icoInfo",
			2:"de_icoWarning",
			3:"de_icoError",
			4:"de_icoQuestion"
	};
	if (defaultIconType == null) defaultIconType = 0;
	var icon = iconTypes[iconType];
	if (icon == null)
		icon = iconTypes[defaultIconType];
	return rootPage.getDecoratedAlertMsg(message, icon);
}

/**
 * Creates a dialog with an error message.
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML which will appear inside the dialog.
 */
function JQAlertError(idDialog, title, message, width, height, callback) {
	var decoratedMsg = getDecoratedAlertMsg(message, "de_icoError");
	JQAlert(idDialog, title, decoratedMsg, width, height, callback);
};

/**
 * Creates a dialog with a warning message.
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML which will appear inside the dialog.
 */
function JQAlertWarning(idDialog, title, message) {
	var decoratedMsg = getDecoratedAlertMsg(message, "de_icoWarning");
	JQAlert(idDialog, title, decoratedMsg);
};
/**
 * Creates a dialog with an info message..
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML which will appear inside the dialog.
 */
function JQAlertInfo(idDialog, title, message) {
	var decoratedMsg = getDecoratedAlertMsg(message, "de_icoInfo");
	JQAlert(idDialog, title, decoratedMsg);
};

/**
 * Create a jdialog like a prompt
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML for prompt message.
 * @param idInput: the input text id.
 * @param actionOk: the name of the function which is called when the OK button is pressed
 * @param actionCanc: the name of the function which is called when the cancel button is pressed
 */
function JQPrompt(idDialog, title, message, initialValue, idInput, actionOk, actionCanc, maxLength) {
	!isDefined(maxLength) ? maxLength = 'none' : null;
	var content = message + "</br></br><input id='"+idInput+"' maxlength= '"+maxLength+"' autofocus='1' onfocus='$(this).select();' value='" + encodeApex(initialValue) + "' style='width:328px'/>";
	createJQDialog(idDialog, 0, actionCanc, "", actionOk, true, "", title, 370, 180, "", "", true, true, false, content, "", false, false);
	return false;
}

/**
 * Creates a dialog with an info message and sets the callback function when the OK button is clicked (info alert).
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML which will appear inside the dialog.
 * @param onOkButton: the name of the function which is called when the OK button is pressed
 */
function JQAlertInfoAndClose(idDialog, title, message, onOkButton) {
	JQAlertInfo(idDialog, title, message);
	setJQDialogButtons(idDialog, onOkButton, "", false);
};

/**
 * Creates a modal and draggable dialog with a question message and sets the event handlers to be used when the Cancel or OK button is pressed.
 * @param idConfirm: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML which will appear inside the dialog.
 * @param onConfirm: the name of the function which is called when the OK button is pressed
 * @param onCancel: the name of the function which is called when the Cancel button is pressed
 */
function JQConfirm(idConfirm, title, message, onConfirm, onCancel) {
	var decoratedMsg = getDecoratedAlertMsg(message, "de_icoQuestion");
	if (onCancel == null || onCancel == "") onCancel = "closeJQDialog('"+idConfirm+"')";
	createJQDialog(idConfirm, 0, "", "", onConfirm, onCancel, "", title, "", "", "", "", true, true, false, decoratedMsg, "", false, false);
	return false;
};

/**
 * Creates a modal and draggable dialog with a question message and sets the event handlers to be used when the Yes or No button is pressed.
 * @param idConfirm: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML which will appear inside the dialog.
 * @param onConfirm: the name of the function which is called when the OK button is pressed
 * @param onCancel: the name of the function which is called when the Cancel button is pressed
 * @param icon: (numeric) icon type dialog, value allowed 0(no icon), 1(info), 2(warning), 3(error) (default 1)
 * @param labelYes: label of yes button (default language translation of yes)
 * @param labelNo: label of no button (default language translation of no)
 */
function JQConfirmYesNo(idConfirm, title, message, onConfirm, onCancel, icon, labelYes, labelNo, width, height) {
	var decoratedMsg = getDecoratedMessage(message, icon, 4);
	if (labelYes == null) labelYes = LANGUAGES.getOriginalLabel("jqdialogDefYesBtn");
	if (labelNo == null) labelNo = LANGUAGES.getOriginalLabel("jqdialogDefNoBtn");
	if (width == null) width = "";
	if (height == null) height = "";
	if (onCancel == null || onCancel == "") onCancel = "closeJQDialog('"+idConfirm+"')";
	createJQDialog(idConfirm, 0, "", "", onConfirm, onCancel, "", title, width, height, "", "", true, true, false, decoratedMsg, "", false, false, labelYes, labelNo);
	return false;
}


/**
 * Creates a dialog with an info message and sets the callback function when the OK button is clicked.
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param message: text/HTML which will appear inside the dialog.
 * @param okCallBack: the name of the function which is called when the OK button is pressed
 */
function jQAlertOkAndAction( title, message, okCallBack, labelOk, width, height) {
	var decoratedMsg = getDecoratedMessage(message, 1, null);
	var idDialog = new Date().getTime() + "_jQAlertOkAndAction" ;
	if (labelOk == null) labelOk = "Ok";
	createJQDialog(idDialog , 0, "", "", okCallBack, false, "", title, width, height, "", "", true, true, false, decoratedMsg, "", false, false, labelOk);
}


/**
 * Creates a dialog with a question message. This dialog is called when an another main dialog is opened.
 * When this dialog is closed on pressing OK button, the main dialog will be closed.
 * @param idDialog: the dialog id.
 * @param message: text/HTML which will appear inside the dialog.
 * @param fromIframe: true/false, it specifies whether the dialog should close  from an iframe.
 * @returns {Boolean}
 */
function jQAlertConfirmAndClose(idDialog, message) {
	var onConfirm = "closeJqDialogAndParent('CONFIRM_JQDIALOG','"+idDialog+"');";
	var idConfirmDialog = new Date().getTime();
	JQConfirm(idConfirmDialog, LANGUAGES.getLabelWithoutSingleQuote("jq_confirm"), message, onConfirm, "closeJQDialog('"+idConfirmDialog+"');");
	return false;
};

/**
 * Close the dialog in case of confirm message. Necessary to close two dialog toghether
 * @param idChild: id dialog of confirm.
 * @param idParent: id dialog of parent.
 */
function closeJqDialogAndParent(idChild, idParent) {
	closeJQDialog(idChild);
	// Il set timeout è per sopperire ad un errore che si verifica solo su IE9
	setTimeout("closeJQDialog('"+idParent+"');",0);
}

/**
 * Creates a dialog with an iframe content.
 * @param idDialog: the dialog id.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param url: it specifies the address of the document to embed in the <iframe>
 * @param width: The width of the dialog, in pixels
 * @param height: The height of the dialog, in pixels
 * @param nameFunBeforeClose: the name of the function which is called before the dialog is closed
 * @param isModal: true/false, this allows you to create dialog which 'dim' the rest of the page when shown.
 * @param isDraggable: If set to true, the dialog will be draggable will be draggable by the titlebar
 * @param isResizable: If set to true, the dialog will be resizeable.
 * @param showScrolling: true/false, it specifies whether or not to display scrollbars in the <iframe>.
 */
function jQDialogIframe(idDialog, title, url, width, height, nameFunBeforeClose, isModal, isDraggable, isResizable, showScrolling) {
	return jQDialogIframeMaxMin(idDialog, title, url, width, height, nameFunBeforeClose, isModal, isDraggable, isResizable, showScrolling, false, false);
};

/**
 * Creates a modal dialog with an iframe content.
 * @param url: it specifies the address of the document to embed in the <iframe>
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param closureMsg: the name of the function which is called before the dialog is closed
 * @param width: The width of the dialog, in pixels
 * @param height: The height of the dialog, in pixels
 */
function openCenterModalWindow(url, title, closureMsg, width, height) {
	var idDialog = "modalWin";
	var closureFunc = null;
	if (closureMsg!="")
		closureFunc = "jQAlertConfirmAndClose('"+idDialog+"', '"+closureMsg+"')";
	return jQDialogIframe(idDialog, title, url, width, height, closureFunc, true, true, false, false);
};


/**
 * Creates a dialog or shows a dialog (if exists) and inserts a message into the dialog content.
 * @param msg: text/HTML which will appear inside the dialog.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param iconClass: image decoration
 */
function alerting(msg, title, iconClass) {
	if (typeof title === "undefined")
		title = "Error";
	if (typeof iconClass === "undefined")
		iconClass = "de_icoError";
	alertInfo(title, msg, 500, 200, false, true, "", iconClass);
};

/**
 * Creates a dialog or shows a dialog (if exists) and inserts a message into the dialog content.
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param msg: text/HTML which will appear inside the dialog.
 * @param width: The width of the dialog, in pixels
 * @param height: The height of the dialog, in pixels
 * @param closeAtEnd: the name of the function which is called when the OK button is pressed
 * @param isError: true/false, it specifies whether or not to display an error message.
 * @param funToCallAtEnd: the name of the function which is called before the dialog is closed
 * @param iconClass: image decoration
 */
function alertInfo(title, msg, width, height, closeAtEnd, isError, funToCallAtEnd, iconClass) {
	if (typeof iconClass === "undefined") {
		if (isError)
			iconClass = "de_icoError";
		else
			iconClass = "de_icoInfo";
	}

	var idDialog = "alertingId";
	var $dialog = rootPage.$("#"+idDialog);
	if (dialogExists($dialog) && $dialog.dialog('isOpen') == true){
		$dialog.append(getDecoratedAlertMsg(msg, iconClass));
	} else {
		rootPage.createJQDialog(idDialog, 0, funToCallAtEnd, "", "closeJQDialog('"+idDialog+"')", false, "", title, width, height, "", "", true, true, true, getDecoratedAlertMsg(msg, iconClass), "", false, false);
	}
};

/*********************************************************************
 * Save the jqDialog window reference into a rootPage array.
 * ******************************************************************* */
function saveWindowReferenceInRootPage(idDialog, objWindow){
	var jqDialogItem = getJqDialogData(idDialog, objWindow);
	if (jqDialogItem!=null){
		var jqDialogObject = getJqDialogDataFromBody();
		jqDialogObject[jqDialogObject.length] = jqDialogItem;
		rootPage.$('body').data('jqDialogs', jqDialogObject);
	}
};
/*********************************************************************
 * Returns the jqDialog window reference.
 * ******************************************************************* */
function getWindowReferenceFromRootPage(idDialog){
	var objWinData = null;
	var jqDialogObject = getJqDialogDataFromBody();
	for (var i=0; i<jqDialogObject.length; i++) {
		if (jqDialogObject[i].idJqDialog == idDialog){
			objWinData =  jqDialogObject[i].objWin;
			break;
		}
	}
	return objWinData;
};
/*********************************************************************
 * Save the jqDialog window reference into a rootPage array.
 * ******************************************************************* */
function removeWindowReferenceInRootPage(idDialog){
	var jqDialogObject = getJqDialogDataFromBody();
	var stuff = [];
	for (var i=0; i<jqDialogObject.length; i++) {
		if (jqDialogObject[i].idJqDialog != idDialog){
			stuff.push(jqDialogObject[i]);
		}
	}
	updateJqDialogDataFromBody(stuff);
};
/*********************************************************************
 * Sets the width to the jqDialog.
 * ******************************************************************* */
function setJQDialogWidth(jqDialog, dialogWidth){
	var width = dialogWidth.toString();
	width = (width=="") ? "300" : width;
	if (width.indexOf("%")!=-1){
		var wWidth = rootPage.$('body').width();
		var dWidth = wWidth * parseInt(width.replace("%",""))/100;
		jqDialog.dialog("option", "width", dWidth);
	}else{
		if (width > 0 || width=='auto'){
			jqDialog.dialog("option", "width", width);
		}
	}
};
/*********************************************************************
 * Sets the height to the jqDialog.
 * ******************************************************************* */
function setJQDialogHeight(jqDialog, dialogHeight){
	var height = dialogHeight.toString();
	height = (height=="") ? "150" : height;
	if (height.indexOf("%")!=-1){
		var wHeight = rootPage.$('body').height();
		var dHeight = wHeight * parseInt(height.replace("%",""))/100;
		jqDialog.dialog("option", "height", dHeight);
	}else{
		if (height > 0 || height=='auto'){
			jqDialog.dialog("option", "height", height);
		}
	}
};
/******************************************************
* Destroy the jqDialog (jquery object and DOM element)
* if it exists
******************************************************/
function destroyJQDialog($dialog, idDialog){
	if (dialogExists($dialog)){

		var iframeChild = $dialog.find("iframe");
		if (iframeChild.size() > 0){
			$(iframeChild).contents().find("head").remove();
			$(iframeChild).contents().find("body").remove();
			$(iframeChild).remove();
			iframeChild.get(0).src = emptyJSPCas;
		}
		$dialog.empty();
		rootPage.$("#" + idDialog).dialog("destroy");
		rootPage.$("#" + idDialog).remove();
		removeWindowReferenceInRootPage(idDialog);
		rootPage.checkContentReference();
	}
};
/**
 * Returns if the dialog exists
 * @param $jqDialog
 * @returns
 */
function dialogExists($jqDialog){
	return $jqDialog && $jqDialog.length>0;
};
/**
 * Sets the dialog title
 * @param idDialog
 * @param title
 */
function setJQDialogTitle (idDialog, title){
	var jqDialog = rootPage.$('#'+idDialog);
	if (dialogExists(jqDialog)){
		jqDialog.dialog("option", "title", title);
	}
};
/**
 * Creates a non modal dialog with an iframe content and with maximize/minimize buttons.
 * @param url: it specifies the address of the document to embed in the <iframe>
 * @param title: text/HTML which will appear inside the title element of the content.
 * @param closureMsg: the name of the function which is called before the dialog is closed
 * @param width: The width of the dialog, in pixels
 * @param height: The height of the dialog, in pixels
 * @param clickOutsideAction
 * @param isResizable
 * @param canMinimize
 * @param canMaximize
 * @returns
 */
function openCenterNonModalWindowMaxMin(idDialog, url, title, closureMsg, width, height, clickOutsideAction, isResizable, canMinimize, canMaximize, canScrolling, winRef) {
	var closureFunc = null;
	if (closureMsg!="")
		closureFunc = "jQAlertConfirmAndClose('"+idDialog+"', '"+closureMsg+"')";
	var scrolling = !(canScrolling)? " scrolling='no'" : " scrolling='auto'";
	var iframeId = "noModalDialogFrame";
	var iframe = "<iframe id='"+iframeId+"' name='d_"+idDialog+"'  class='jqDialogIframe' src='"+url+"' frameborder='0' style='width:100%;height:99%;' "+scrolling+"></iframe>";
	return createJQDialog(idDialog, 0, closureFunc, "", "", false, clickOutsideAction, title, width, height, 0, 0, false, true, isResizable, iframe, "", canMinimize, canMaximize, null , null , false, false, false, false, winRef);
};

/**
* Creates a dialog with an iframe content.
* @param idDialog: the dialog id.
* @param title: text/HTML which will appear inside the title element of the content.
* @param url: it specifies the address of the document to embed in the <iframe>
* @param width: The width of the dialog, in pixels
* @param height: The height of the dialog, in pixels
* @param nameFunBeforeClose: the name of the function which is called before the dialog is closed
* @param isModal: true/false, this allows you to create dialog which 'dim' the rest of the page when shown.
* @param isDraggable: If set to true, the dialog will be draggable will be draggable by the titlebar
* @param isResizable: If set to true, the dialog will be resizeable.
* @param showScrolling: true/false, it specifies whether or not to display scrollbars in the <iframe>.
* @param canMinimize
* @param canMaximize
*/
function jQDialogIframeMaxMin(idDialog, title, url, width, height, nameFunBeforeClose, isModal, isDraggable, isResizable, showScrolling, canMinimize, canMaximize, winRef) {
	var scrolling = showScrolling ? "" : " scrolling='no'";
	var iframe = "<iframe id='jqDialogIframe_" + idDialog + "' name='jqDialogIframe' class='jqDialogIframe' src='"+url+"' frameborder='0' style='width:100%;height:99%;'"+scrolling+"></iframe>";
	return createJQDialog(idDialog, 0, nameFunBeforeClose, "", "", false, "", title, width, height, "", "", isModal, isDraggable, isResizable, iframe, "", canMinimize, canMaximize, null, null , false, false, false, false, winRef);
};

/**
 * Dialog con iframe massimizzabile, iconizzabile e che si apre in full screen
 */
function jQDialogIframeMaximized(idDialog, title, url, width, height, nameFunBeforeClose, isModal, isDraggable, isResizable, showScrolling, winRef) {
	var scrolling = showScrolling ? "" : " scrolling='no'";
	var iframe = "<iframe id='jqDialogIframe_" + idDialog + "' name='jqDialogIframe' class='jqDialogIframe' src='"+url+"' frameborder='0' style='width:100%;height:99%;'"+scrolling+"></iframe>";
	return createJQDialog(idDialog, 0, nameFunBeforeClose, "", "", false, "", title, width, height, "", "", isModal, isDraggable, isResizable, iframe, "", true, true, null, null, null, null, true, false, winRef);
};

/**
 * Return the jqDialog data entered into an array
 * @param objWindow
 * @param idDialog
 */
function getJqDialogData(idDialog, objWindow) {
	var nw = {};
	nw.idJqDialog = idDialog;
	nw.objWin = objWindow;
    return nw;
};
/**
 * Return the jqDialog data info reading from body
 */
function getJqDialogDataFromBody(contentUidFilter){
	var jqDialogObject = [];
	var jqDialogData = rootPage.$('body').data('jqDialogs');
	if (jqDialogData && jqDialogData.length > 0){
		if (contentUidFilter) {
			for (var i in jqDialogData)
				if (getJQDialogDataValue(jqDialogData[i].idJqDialog, 'contentUID') == contentUidFilter)
					jqDialogObject.push(jqDialogData[i]);
		} else
			jqDialogObject = jqDialogData;
	}
	return jqDialogObject;
};

/**
 * Close all rootPage open jqDialog
 */
function closeAllRootJqDialog() {
	var openDialogs = getJqDialogDataFromBody();
	for (var i in openDialogs) {
		try{
			closeJQDialog(openDialogs[i].idJqDialog);
		} catch (e) {
			JQAlertError("errorCloseAllDlg", "", e);
		}
	}
}

/**
 * Update the jqDialog data
 */
function updateJqDialogDataFromBody(arrTmp){
	if (arrTmp.length > 0){
		rootPage.$('body').data("jqDialogs",arrTmp);
	}else{
		rootPage.$('body').removeData("jqDialogs");
	}
};

function createJQDialogWithDataProvider(idDialog, nameFunBeforeClose, nameFunClose, nameFunOKBtn,
cancelButton, nameFunClickOutside, title, width, height, posX, posY, isModal, isDraggable,
isResizable, jqLoadingMessage, canMinimize, canMaximize, labelOk, labelCanc, dataProviderId, context, isAutoHeight, infiniteScroll, contentCssClass, resizeStartCallback, resizeStopCallback, maximizeCallback, restoreCallback){

	createJQDialog (idDialog, 0, nameFunBeforeClose, nameFunClose, nameFunOKBtn, cancelButton, nameFunClickOutside, title, width, height, posX, posY, isModal, isDraggable,
			isResizable, '','', canMinimize, canMaximize, labelOk, labelCanc, null, isAutoHeight, null, infiniteScroll, null, contentCssClass, resizeStartCallback, resizeStopCallback, maximizeCallback, restoreCallback);

	 setJQDialogContent(idDialog, getJqContentForLoading(''));
	$.ajax({
		data: {revent:'GET_DATA',a0:dataProviderId,a1:context},
		success: function(data, textStatus, jqXHR) {
			//if (data && data.length > 0 && data.indexOf('errorMsg')==-1){
				var $dialog = rootPage.$('#'+idDialog);
				$dialog.html("");
				rootPage.decorateContentToSelector(data, $dialog.selector, dataProviderId, context);
//			}else{
//				var labelNoResult = LANGUAGES.getOriginalLabel('noResultSrc');
//				setJQDialogContent(idDialog, labelNoResult);
//			}

		}
	});
};
/*********************************************************************
 * Returns the jqDialog id by window reference.
 * ******************************************************************* */
function getJQDialogReferenceFromRootPage(objWindow){
	var jqDialogDataId = null;
	var jqDialogObject = getJqDialogDataFromBody();
	for (var i=0; i<jqDialogObject.length; i++) {
		if (jqDialogObject[i].objWin == objWindow){
			jqDialogDataId =  jqDialogObject[i].idJqDialog;
			break;
		}
	}
	return jqDialogDataId;
};

/*********************************************************************
 * Returns the jqDialog id by a node id reference internal
 * ******************************************************************* */
function getIdDialogFromInternalNodeId(internalNodeId) {
	return $("#"+internalNodeId).closest(".ui-dialog-content").attr("id");
}

/**
 * Si occupa di restituire l'id dell'eventuale dialog a cui appartiene il target node passato
 * @param node
 * @returns boolean
 */
function getIdDialogContainer(node){
	var $searchDialog = null;

	var iframe = window.frameElement;

	if(iframe){
		$searchDialog = $(iframe).closest(".ui-dialog-content");
	}
	else{
		$searchDialog = $(node).closest(".ui-dialog-content");
	}

	if($searchDialog.length){
		return $searchDialog.attr("id");
	}

	return null;
}

function getJQDialogIframeParentReference() {
	return $('iframe[name=jqDialogIframe]', parent.document);
}

/**********************************************************************
 * Open dialog for uploading file image
 * ******************************************************************** */
function openUploadImageDialog(imageType, referenceObjectId, wizardDivId, callbackClose, owner) {
	var ctx = buildNewCtxObject();
	addDataToCtx(ctx, "wizardDataType", imageType);
	addDataToCtx(ctx, "referenceObjectID", referenceObjectId);
	if (wizardDivId)
		addDataToCtx(ctx, "wizardDivId", wizardDivId);
	if (owner)
		addDataToCtx(ctx, "owner", owner);

	var rasterCtx = getRasterCtxContainer(ctx);
	createJQDialogByDPrWithOptions("uploadImgDlg", "uploadImg", rasterCtx, "", 800, 557);
	var jqDialog = rootPage.$("#uploadImgDlg");
	jqDialog.data("callbackClose", callbackClose);
	jqDialog.data("imageType", imageType);
	jqDialog.data("referenceObjectId", referenceObjectId);
};

/**********************************************************************
 * Open dialog for send private message
 * ******************************************************************** */
function openPrivateDiscussionDialog(users) {
	var ctx = buildNewCtxObject();

	if (isDefined(users)) {
		addDataToCtx(ctx, "involvedUsers", users);
	}

	var rasterCtx = getRasterCtxContainer(ctx);

	closeAllTips(); //Chiudo tutti i tooltip esistenti per fare spazio al popup in questione
	rootPage.createJQDialogByDPrWithOptions("privateDialog", "privateDiscussion", rasterCtx, getLabel('sendAMessage'), 550, 550, true);
};

/**********************************************************************
 *  Open dialog for send signal
 * ******************************************************************** */
/**
 * Open the dialog for signal
 */
function openCreateSignalDialog(ctx){
	createJQDialogByDPrWithOptions('signalDialog', 'signalDiscussion', ctx, LANGUAGES.getOriginalLabel("sendSignal"), 550, 550, true);
}

/**
 * Open the signal dialog when you click on yhe manu item in all contents
 * @param obj
 */
function openSendSignalDialog(obj) {
	
	try {
		if(!Utilities.isObject(obj)){
			obj = unescape(decodeURIComponent(obj));
			obj = JSON.parse(obj);
		}
	} catch (e) {
		obj = {};
	}
	
	var ctx = null;
	var verifyObj = obj.offsetParent;

	if(isDefined(verifyObj)){
		ctx = getCtx(obj);
		addDataToCtx(ctx, "createSignal", "true");
		ctx = getRasterCtxContainer(ctx);
	}
	else if(!isDefined(obj.ctx)){
		ctx = new ctxManager();
		ctx.set("createSignal", "true");
		ctx = getRasterCtxContainer(ctx.ctxObject);
	}
	else{
		ctx = new ctxManager(obj.ctx).toString();
	}


	if(isDefined(ctx)){
		var escapeText 		= unescape(decodeURIComponent(ctx));
		var ctxParse 		= JSON.parse(escapeText);

		var refObjContextDs = getCtxValue('refObjContextDs',ctxParse.ctx);

		if(isDefined(refObjContextDs) && refObjContextDs != ''){
			var ctxMng = new ctxManager(ctxParse.ctx);
			var objContextDs = JSON.parse(refObjContextDs);

			if(isDefined(objContextDs) && isDefined(objContextDs.data) && (objContextDs.data instanceof Array))
			{
				for(var i=0; i<objContextDs.data.length; i++){
					objContextDs.data[i] = getTextEncode(objContextDs.data[i]);
				}

				objContextDs = JSON.stringify(objContextDs);
				ctxMng.set("refObjContextDs", objContextDs);
			}

			ctx = ctxMng.toString();
		}

		closeAllTips();
		openCreateSignalDialog(ctx);
	}
};


/**
 * Open the signal dialog when you click on yhe manu item in a userDialog
 * @param refObjId
 * @param refObjectType
 * @param owner
 */
function openSendSignalDialogNoCtxObj(refObjId, refObjectType, owner) {
	var ctx = new ctxManager();
	ctx.set("createSignal", "true");
	if (refObjId!=null)
		ctx.set('refObjId', refObjId);
	if (refObjectType!=null)
		ctx.set('refObjectType', refObjectType);
	if (owner!=null)
		ctx.set('owner', owner);

	closeAllTips();
	openCreateSignalDialog(ctx.toString());
};

/**
 * Apre la dialog per la crezione dei Task preimpostando l'appartenenza del Task allo spazio specificato
 */
function openCreateTaskFromSpaceDialog(spaceId) {
	var ctx = window.buildNewCtxObject();
	window.addDataToCtx(ctx, 'spaceId', spaceId);
	window.openCreateTaskForm(ctx);
};

/**********************************************************************
 *  Open dialog for share signal
 * ******************************************************************** */
function openShareSignal(contextContainer) {
	createJQDialogByDPrWithOptions("share", "shareSignal", "", LANGUAGES.getOriginalLabel("share"), 400, "auto");
	var jqDialog = rootPage.$("#share");
	jqDialog.data("contextContainer", contextContainer);
};

function openModifySignal(contextContainer, tags, category, title) {

	var json = buildNewRenderedData("modifySignal_BaseTMPL", {"tags" : tags, "categs":category, "title" : title});

	var localVars = {"ctx" : contextContainer.ctx};

	var $html = $(rootPage.templateRenderizer(json, localVars));

	$html.dialog({
		modal: true,
		width: 570,
		height: "auto",
		title: LANGUAGES.getOriginalLabel("scModify"),
		close: function( event, ui ) {
			$html.remove();
		}
	});
};

/**********************************************************************
 *  Open dialog for change expired password
 * ******************************************************************** */
function openLoginChangePwd(contextContainer, title) {
	var json = buildNewRenderedData("pwdExpired_BaseTMPL", {});
	var localVars = {"ctx" : contextContainer.ctx};
	var $html = $(rootPage.templateRenderizer(json, localVars));

	$html.dialog({
		modal: true,
		resizable:false,
		width:  "auto",
		height: "auto",
		title: title,
		close: function( event, ui ) {
			$html.remove();
		}
	});
};


/**********************************************************************
 *  Open dialog for share private
 * ******************************************************************** */
function openSharePrivate(contextContainer) {
	createJQDialogByDPrWithOptions("share", "sharePrivate", "", LANGUAGES.getOriginalLabel("share"), 400, "auto");
	var jqDialog = rootPage.$("#share");
	jqDialog.data("contextContainer", contextContainer);
};

/**********************************************************************
 *  Open dialog for forward signal
 * ******************************************************************** */
function openForwardSignal(contextContainer) {
	createJQDialogByDPrWithOptions("forward", "forwardSignal", "", LANGUAGES.getOriginalLabel("forward"), 400, "auto");
	var jqDialog = rootPage.$("#forward");
	jqDialog.data("contextContainer", contextContainer);
};

/**********************************************************************
 *  Open dialog for forward private
 * ******************************************************************** */
function openForwardPrivate(contextContainer) {
	createJQDialogByDPrWithOptions("forward", "forwardPrivate", "", LANGUAGES.getOriginalLabel("forward"), 400, "auto");
	var jqDialog = rootPage.$("#forward");
	jqDialog.data("contextContainer", contextContainer);
};

function getJQDialogDefaultOptions() {
	var defaults = {
			nameFunBeforeClose:	 	"",
			nameFunClose:			"",
			nameFunOKBtn:			"",
			cancelButton:			"",
			nameFunClickOutside:	"",
			title:					"",
			width:					400,
			height:					400,
			posX:					"",
			posY:					"",
			isModal:				true,
			isDraggable:			true,
			isResizable:			false,
			loadingMessage:			"",
			canMinimize:			false,
			canMaximize:			false,
			labelOk:				"",
			labelCancel:			"",
			isAutoHeight:			null,
			infiniteScroll:			null,
			contentCssClass:		null,
			resizeStartCallback:	null,
			resizeStopCallback:		null,
			maximizeCallback:		null,
			restoreCallback:		null
	};

	return defaults;
}

/**
 * Crea una dialog contenente riferita a un dataprovider. Le opzioni di frontend relative alla creazione della
 * dialog sono passate come oggetto json con il parametro option.
 * @param idDialog
 * @param dataProviderId
 * @param context
 * @param options
 */
function jQDialogDP(idDialog, dataProviderId, context, options){

	var defaults = getJQDialogDefaultOptions();

	var options = $.extend({}, defaults, options);

	createJQDialog (idDialog, 0, options.nameFunBeforeClose, options.nameFunClose, options.nameFunOKBtn,
			options.cancelButton, options.nameFunClickOutside, options.title, options.width, options.height, options.posX, options.posY,
			options.isModal, options.isDraggable, options.isResizable, '','', options.canMinimize, options.canMaximize,
			options.labelOk, options.labelCanc, null, options.isAutoHeight, null, options.infiniteScroll, null, options.contentCssClass,
			options.resizeStartCallback, options.resizeStopCallback, options.maximizeCallback, options.restoreCallback);

	setJQDialogContent(idDialog, getJqContentForLoading(''));

	$.ajax({
		data: {revent:'GET_DATA',a0:dataProviderId,a1:context},
		success: function(data, textStatus, jqXHR) {
				var $dialog = rootPage.$('#'+idDialog);
				$dialog.html("");
				rootPage.decorateContentToSelector(data, $dialog.selector, dataProviderId, context);
		}
	});
};



function createJQDialogByDataProvider(idDialog, dataProviderId, context){
	createJQDialogWithDataProvider(idDialog, "", "", "",
			"", "", "", "", "", "", "", true, true,
			false, "", false, false, "", "", dataProviderId, context);
};
function createJQDialogByDPWithTitle(idDialog, dataProviderId, context, title){
	createJQDialogWithDataProvider(idDialog, "", "", "",
			"", "", title, "", "", "", "", true, true,
			false, "", false, false, "", "", dataProviderId, context);
};
function createJQDialogByDPrWithOptions(idDialog, dataProviderId, context, title, width, height, isAutoHeight){
	createJQDialogWithDataProvider(idDialog, "", "", "",
			"", "", title, width, height, "", "", true, true,
			false, "", false, false, "", "", dataProviderId, context, isAutoHeight);
};
function createJQDialogByDPrBeforeClose(idDialog, dataProviderId, context, width, height, beforeClose){
	createJQDialogWithDataProvider(idDialog, beforeClose, "", "",
			"", "", "", width, height, "", "", true, true,
			false, "", false, false, "", "", dataProviderId, context);
};
function createJQDialogByDPrOkClick(idDialog, dataProviderId, context, title, width, height, funOkClick, labelOk, labelCancel){
	createJQDialogWithDataProvider(idDialog, "", "", funOkClick,
			"", "", title, width, height, "", "", true, true,
			false, "", false, false, labelOk, labelCancel, dataProviderId, context);
};

function createJQDialogByDPrWithCallbackClose(idDialog, dataProviderId, context, title, width, height, callbackClose, contentCssClass){
	createJQDialogWithDataProvider(idDialog, callbackClose, "", "",
			"", "", title, width, height, "", "", true, true,
			false, "", false, false, "", "", dataProviderId, context, null, null, contentCssClass );
};
function createJQDialogByDPrResizable(idDialog, dataProviderId, context, title, width, height){
	createJQDialogWithDataProvider(idDialog, "", "", "",
			"", "", title, width, height, "", "", true, true,
			true, "", true, true, "", "", dataProviderId, context);
};
function createJQDialogByDPrResizableNoModal(idDialog, dataProviderId, context, title, width, height){
	createJQDialogWithDataProvider(idDialog, "", "", "",
			"", "", title, width, height, "", "", false, true,
			true, "", true, true, "", "", dataProviderId, context);
};
function createJQDialogByDPrNoResizableNoModal(idDialog, dataProviderId, context, title, width, height){
	createJQDialogWithDataProvider(idDialog, "", "", "",
			"", "", title, width, height, "", "", false, true,
			false, "", true, true, "", "", dataProviderId, context);
};
/**
 * Crea una dialog contenente un mashboard in un iframe e con i pulsanti customizzati.
 * La selezione del tasto di conferma richiama la funzione dcyExecuteMshAction
 * che deve essere dichiarata nel mashboard: in tal modo confermando potrà essere eseguita
 * l'azione desiderata nel mashboard
 * @param idDialog
 * @param url
 * @param title
 * @param width
 * @param height
 * @param idLblOK
 * @param idLblCancel
 * @param classOK
 * @param classCancel
 * @returns
 */
function openMashboardIntoModalDialogWithCustomButtons(idDialog, url, title, width, height, idLblOK, idLblCancel, classOK, classCancel){
	var iframe = "<iframe id='jqDialogIframe_" + idDialog + "' name='jqDialogIframe' class='jqDialogIframe' src='"+url+"' frameborder='0' style='width:100%;height:99%;'  scrolling='no'></iframe>";
	var mDialog = createJQDialog(idDialog, 0, "", "", "rootPage.jqDialogIframe.dcyExecuteMshAction()", true, "", title, width, height, "", "", true, true, false, iframe, "", false, false);
	 setJQDialogButtons (idDialog, LANGUAGES.getOriginalLabel(idLblOK), null, classOK, null, true);
	return mDialog;
};

/**
 * Restituisce la finestra chiamante della dialog
 */
function getDialogWindowOpener(){
	var fwin = null;
	var dialogID = getParentJQDialogID();
	fwin = getWindowReferenceFromRootPage(dialogID);
	return fwin;

};

/**
 * Return the parent dialog id
 * @returns
 */
function getParentJQDialogID(){
	var dialogID = null;
	var currentIframe = null;
	var dialogHasBeenFound = false;
	
	var arrFrames = parent.document.getElementsByTagName("IFRAME");
	for (var i = 0; i < arrFrames.length; i++) {
		var parentIframe  = arrFrames[i];
		if (parentIframe.contentWindow == window) {
			currentIframe = parentIframe;
			break;
		}
	}
	if (currentIframe!=null && currentIframe.id){
		var jqDialogObject = getJqDialogDataFromBody();
		for (var i=0; i<jqDialogObject.length; i++) {
			dialogID = jqDialogObject[i].idJqDialog;
			if ((currentIframe.id).indexOf(dialogID) !=-1) {
				dialogHasBeenFound = true;
				break;
			}
		}
		
		if (!dialogHasBeenFound){
			var isModalDT = ($(currentIframe).hasClass('jqDialogIframe') && currentIframe.id == 'noModalDialogFrame') ? false : true;
			for (var i=0; i<jqDialogObject.length; i++) {
				dialogID = jqDialogObject[i].idJqDialog;
				var dialogIframe = rootPage.$('#'+dialogID).find('.jqDialogIframe').get(0);
				if (dialogIframe && dialogIframe !=null){
					var innerDoc = dialogIframe.contentDocument || dialogIframe.contentWindow.document;
					//The first condition managing the case DT standard (also through execute object)
					if (isModalDT){
						var firstElement = innerDoc.getElementById(currentIframe.id);
						if (firstElement){
							dialogHasBeenFound = true;
							break;
						}
					}
					
					//In this second step managing also the case in which the DT is running by JS code through external function
					if ($(dialogIframe).attr('name') == $(currentIframe).attr('name')){
						dialogHasBeenFound = true;
						break;
					}
				}
			}
		}
	}

	return dialogID;
};

/**
 * Apre una dialog con la preview del pdf del contenuto
 * @param pdfLink
 */
function viewPeviewExportPdf(pdfLink) {
	var dlgId = 'socialContentPdfViewDlg' + getRandomString();
	jQDialogIframe(dlgId, LANGUAGES.getOriginalLabel('ExpMshPdfPreviewDlgTitle'), pdfLink, 900, 700, "", true, true, true, true);
}


/**
 * Author : Pagano Francesco
 * Reference Jquery Ticket : http://bugs.jqueryui.com/ticket/10116
 * Il metodo è workaround sulla gestione nativa di jquery-ui che si occupa della visibilità
 * delle dialog rispetto ad altre.Infatti l'anomalia si presenta nel caso in cui, tra le dialog visibili, ce ne siano alcune che
 * contiengono dei contenuti flash/video/iframe/scroll; nello switch effettuato tra le dialog, gli eventuali contenuti  flash/video/iframe/scroll
 * vengono erroneamente ricaricati.
 * Tramite questo workaround viene eseguito un override del metodo _moveToTop garantendo la visibilità
 * modificando i valori di z-index tra finestre e quindi evitando tale anomalia.
 * @param $target : selettore $ su cui verrà salvata la gestione nativa che verrà successivamente sovrascritta
 * @returns {Function} : una callBack che ripristina la gestione nativa precedentemente sovrascritta
 */
function moveToTopIframeFix($target){

	$target.data('_moveToTopOriginal', $.ui.dialog.prototype._moveToTop);

	$.ui.dialog.prototype._moveToTop = function (event, silent) {
		var zIndexDefault = 100;
		var $elementsOnSameLevel = $(window.parent.document).find('.ui-dialog:visible');
		var heighestZIndex = zIndexDefault;

		$.each($elementsOnSameLevel, function(index, element) {
			var zIndexOfElement = $(element).css('z-index');
			if (zIndexOfElement) {
				var zIndexOfElementAsNumber = parseInt(zIndexOfElement,10) || 0;
				if (zIndexOfElementAsNumber > heighestZIndex) {
					heighestZIndex = zIndexOfElementAsNumber;
				}
			}
		});
		var currentZIndex = parseInt(this.uiDialog.css('z-index'),10);

		var moved;
		if (currentZIndex > heighestZIndex) {
			moved = false;
		} else {
			this.uiDialog.css('z-index', heighestZIndex + 1);
			moved = true;
		}

		if ( moved && !silent ) {
			this._trigger( "focus", event );
		}

		return moved;
	};

	var callback = function(){
		$.ui.dialog.prototype._moveToTop = $target.data('_moveToTopOriginal');
	};

	return callback;
}

/*!
 * jQuery DialogExtend 2.0.3
 *
 * Copyright 2013 Crab, ROMB
 *
 * Licensed under MIT
 * 	 https://code.google.com/p/jquery-dialogextend/
 *   https://github.com/ROMB/jquery-dialogextend
 *
 * Project Home:
 *   http://code.google.com/p/jquery-dialogextend/
 *
 */
(function() {
	  var $;

	  $ = jQuery;

	  $.widget("ui.dialogExtend", {
	    version: "2.0.0",
	    modes: {},
	    options: {
	      "closable": true,
	      "dblclick": false,
	      "titlebar": false,
	      "icons": {
	        "close": "ui-icon-closethick",
	        "restore": "ui-icon-newwin"
	      },
	      "load": null,
	      "beforeRestore": null,
	      "restore": null
	    },
	    _create: function() {
	      loadCssResource('/jsLib/welcome/dialogExtend.css');
	      this._state = "normal";
	      this.minimizedDialogWidth = 200;
	      if (!$(this.element[0]).data("ui-dialog")) {
	        $.error("jQuery.dialogExtend Error : Only jQuery UI Dialog element is accepted");
	      }
	      this._verifyOptions();
	      this._initStyles();
	      this._initButtons();
	      this._initTitleBar();
	      this._setState("normal");
	      this._on("load", function(e) {
	        return logToConsole(e);
	      });
	      if(this.options.isMaximized){
				this.maximize();
	      }
	      return this._trigger("load");
	    },
	    _setState: function(state) {
	      $(this.element[0]).removeClass("ui-dialog-" + this._state).addClass("ui-dialog-" + state);
	      return this._state = state;
	    },
	    _verifyOptions: function() {
	      var name, _ref, _results;

	      if (this.options.dblclick && !(this.options.dblclick in this.modes)) {
	        $.error("jQuery.dialogExtend Error : Invalid <dblclick> value '" + this.options.dblclick + "'");
	        this.options.dblclick = false;
	      }
	      if (this.options.titlebar && ((_ref = this.options.titlebar) !== "none" && _ref !== "transparent")) {
	        $.error("jQuery.dialogExtend Error : Invalid <titlebar> value '" + this.options.titlebar + "'");
	        this.options.titlebar = false;
	      }
	      _results = [];
	      for (name in this.modes) {
	        if (this["_verifyOptions_" + name]) {
	          _results.push(this["_verifyOptions_" + name]());
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    },
	    _initStyles: function() {
	      var name, style, _results;

	      if (!$(".dialog-extend-css").length) {
	        style = '';
	        style += '<style class="dialog-extend-css" type="text/css">';
	        style += '.ui-dialog .ui-dialog-titlebar-buttonpane>a { float: right; }';
	        style += '.ui-dialog .ui-dialog-titlebar-restore { width: 19px; height: 18px; }';
	        style += '.ui-dialog .ui-dialog-titlebar-restore span { display: block; margin: 1px; }';
	        style += '.ui-dialog .ui-dialog-titlebar-restore:hover,';
	        style += '.ui-dialog .ui-dialog-titlebar-restore:focus { padding: 0; }';
	        style += '.ui-dialog .ui-dialog-titlebar ::selection { background-color: transparent; }';
	        style += '</style>';
	        $(style).appendTo("body");
	      }
	      _results = [];
	      for (name in this.modes) {
	        _results.push(this["_initStyles_" + name]());
	      }
	      return _results;
	    },
	    _initButtons: function() {
	      var buttonPane, mode, name, titlebar, _ref,
	        _this = this;

	      titlebar = $(this.element[0]).dialog("widget").find(".ui-dialog-titlebar");
	      buttonPane = $('<div class="ui-dialog-titlebar-buttonpane"></div>').appendTo(titlebar);
	      buttonPane.css({
	        "position": "absolute",
	        "top": "50%",
	        "right": "0.3em",
	        "margin-top": "-10px",
	        "height": "18px"
	      });
	      titlebar.find(".ui-dialog-titlebar-close").css({
	        "position": "relative",
	        "float": "right",
	        "top": "auto",
	        "right": "auto",
	        "margin": 0
	      }).find(".ui-icon").removeClass("ui-icon-closethick").addClass(this.options.icons.close).end().appendTo(buttonPane).end();
	      buttonPane.append('<a class="ui-dialog-titlebar-restore ui-corner-all ui-state-default" href="#"><span class="ui-icon ' + this.options.icons.restore + '">restore</span></a>').find('.ui-dialog-titlebar-restore').attr("role", "button").mouseover(function() {
	        return $(this).addClass("ui-state-hover");
	      }).mouseout(function() {
	        return $(this).removeClass("ui-state-hover");
	      }).focus(function() {
	        return $(this).addClass("ui-state-focus");
	      }).blur(function() {
	        return $(this).removeClass("ui-state-focus");
	      }).end().find(".ui-dialog-titlebar-close").toggle(this.options.closable).end().find(".ui-dialog-titlebar-restore").hide().click(function(e) {
	        e.preventDefault();
	        return _this.restore();
	      }).end();
	      _ref = this.modes;
	      for (name in _ref) {
	        mode = _ref[name];
	        this._initModuleButton(name, mode);
	      }
	      return titlebar.dblclick(function(evt) {
	        if (_this.options.dblclick) {
	          if (_this._state !== "normal") {
	            return _this.restore();
	          } else {
	            return _this[_this.options.dblclick]();
	          }
	        }
	      }).select(function() {
	        return false;
	      });
	    },
	    _initModuleButton: function(name, mode) {
	      var buttonPane,
	        _this = this;

	      buttonPane = $(this.element[0]).dialog("widget").find('.ui-dialog-titlebar-buttonpane');
	      return buttonPane.append('<a class="ui-dialog-titlebar-' + name + ' ui-corner-all ui-state-default" href="#"><span class="ui-icon ' + this.options.icons[name] + '">' + name + '</span></a>').find(".ui-dialog-titlebar-" + name).attr("role", "button").mouseover(function() {
	        return $(this).addClass("ui-state-hover");
	      }).mouseout(function() {
	        return $(this).removeClass("ui-state-hover");
	      }).focus(function() {
	        return $(this).addClass("ui-state-focus");
	      }).blur(function() {
	        return $(this).removeClass("ui-state-focus");
	      }).end().find(".ui-dialog-titlebar-" + name).toggle(this.options[mode.option]).click(function(e) {
	        e.preventDefault();
	        return _this[name]();
	      }).end();
	    },
	    _initTitleBar: function() {
	      var handle;

	      switch (this.options.titlebar) {
	        case false:
	          return 0;
	        case "none":
	          if ($(this.element[0]).dialog("option", "draggable")) {
	            handle = $("<div />").addClass("ui-dialog-draggable-handle").css("cursor", "move").height(5);
	            $(this.element[0]).dialog("widget").prepend(handle).draggable("option", "handle", handle);
	          }
	          return $(this.element[0]).dialog("widget").find(".ui-dialog-titlebar").find(".ui-dialog-title").html("&nbsp;").end().css({
	            "background-color": "transparent",
	            "background-image": "none",
	            "border": 0,
	            "position": "absolute",
	            "right": 0,
	            "top": 0,
	            "z-index": 9999
	          }).end();
	        case "transparent":
	          return $(this.element[0]).dialog("widget").find(".ui-dialog-titlebar").css({
	            "background-color": "transparent",
	            "background-image": "none",
	            "border": 0
	          });
	        default:
	          return $.error("jQuery.dialogExtend Error : Invalid <titlebar> value '" + this.options.titlebar + "'");
	      }
	    },
	    state: function() {
	      return this._state;
	    },
	    restore: function() {
	      this._trigger("beforeRestore");
	      this._restore();
	      this._setState("normal");
	      this._toggleButtons();
	      return this._trigger("restore");
	    },
	    _restore: function() {
	      if (this._state !== "normal") {
	    	var original = this._loadSnapshot();
	    	$(this.element[0]).dialog("widget").off('drag.dialogExtend').find(".ui-dialog-titlebar").css("cursor","move");
	    	original.config.resizable ? $(this.element[0]).dialog("widget").resizable("enable") : null;
	        return this["_restore_" + this._state]();
	      }
	    },
	    _saveSnapshot: function() {
	      if (this._state === "normal") {
	        this.original_config_resizable = $(this.element[0]).dialog("option", "resizable");
	        this.original_config_draggable = $(this.element[0]).dialog("option", "draggable");
	        this.original_size_height = $(this.element[0]).dialog("widget").outerHeight();
	        this.original_size_width = $(this.element[0]).dialog("widget").outerWidth();
	        this.original_size_maxHeight = $(this.element[0]).dialog("option", "maxHeight");
	        this.original_position_mode = $(this.element[0]).dialog("widget").css("position");
	        this.original_position_left = $(this.element[0]).dialog("widget").offset().left - $('body').scrollLeft();
	        this.original_position_top = $(this.element[0]).dialog("widget").offset().top - $('body').scrollTop();
	        return this.original_titlebar_wrap = $(this.element[0]).dialog("widget").find(".ui-dialog-titlebar").css("white-space");
	      }
	    },
	    _loadSnapshot: function() {
	      return {
	        "config": {
	          "resizable": this.original_config_resizable,
	          "draggable": this.original_config_draggable
	        },
	        "size": {
	          "height": this.original_size_height,
	          "width": this.original_size_width,
	          "maxHeight": this.original_size_maxHeight
	        },
	        "position": {
	          "mode": this.original_position_mode,
	          "left": this.original_position_left,
	          "top": this.original_position_top
	        },
	        "titlebar": {
	          "wrap": this.original_titlebar_wrap
	        }
	      };
	    },
	    _toggleButtons: function() {
	      var mode, name, _ref, _ref1, _results;

	      $(this.element[0]).dialog("widget").find(".ui-dialog-titlebar-restore").toggle(this._state !== "normal").css({
	        "right": "1.4em"
	      }).end();
	      _ref = this.modes;
	      for (name in _ref) {
	        mode = _ref[name];
	        $(this.element[0]).dialog("widget").find(".ui-dialog-titlebar-" + name).toggle(this._state !== mode.state && this.options[mode.option]);
	      }
	      var $restoreIcon = $(this.element[0]).dialog('widget').find('.ui-dialog-titlebar-restore');
		  if(this._state == "maximized" && !this.options.maximizable && this.options.isMaximized && $restoreIcon.is(':visible')){
				$restoreIcon.hide();
		  }
	      _ref1 = this.modes;
	      _results = [];
	      for (name in _ref1) {
	        mode = _ref1[name];
	        if (mode.state === this._state) {
	          _results.push($(this.element[0]).dialog("widget").find(".ui-dialog-titlebar-restore").insertAfter($(this.element[0]).dialog("widget").find(".ui-dialog-titlebar-" + name)).end());
	        } else {
	          _results.push(void 0);
	        }
	      }
	      return _results;
	    },
	    _repositionDialogs: function() {
	    	var minimizedDialogWidth = this.minimizedDialogWidth;
	        jQuery('.ui-dialog.minimized').each(function(i, element){
	            var positionLeft = i * minimizedDialogWidth;
	            $(element).css('left', positionLeft);
	        });
	    }
	  });

	}).call(this);

	(function() {
	  var $;

	  $ = jQuery;

	  $.extend(true, $.ui.dialogExtend.prototype, {
	    modes: {
	      "collapse": {
	        option: "collapsable",
	        state: "collapsed"
	      }
	    },
	    options: {
	      "collapsable": false,
	      "icons": {
	        "collapse": "ui-icon-triangle-1-s"
	      },
	      "beforeCollapse": null,
	      "collapse": null
	    },
	    collapse: function() {
	      var newHeight;

	      newHeight = $(this.element[0]).dialog("widget").find(".ui-dialog-titlebar").height() + 15;
	      this._trigger("beforeCollapse");
	      if (this._state !== "normal") {
	        this._restore();
	      }
	      this._saveSnapshot();
	      $(this.element[0]).dialog("option", {
//	        "resizable": false,
	        "height": newHeight,
	        "maxHeight": newHeight
	      }).on('dialogclose', this._collapse_restore).hide().dialog("widget").find(".ui-dialog-buttonpane:visible").hide().end().find(".ui-dialog-titlebar").css("white-space", "nowrap").end().find(".ui-dialog-content");

	      var original = this._loadSnapshot();

	      if (original.config.resizable) {
	    	  $(this.element[0]).dialog("widget").resizable("disable").removeClass("ui-state-disabled");
	      }

	      this._setState("collapsed");
	      this._toggleButtons();
	      return this._trigger("collapse");
	    },
	    _restore_collapsed: function() {
	      var original;

	      original = this._loadSnapshot();
	      return $(this.element[0]).show().dialog("widget").find(".ui-dialog-buttonpane:hidden").show().end().find(".ui-dialog-titlebar").css("white-space", original.titlebar.wrap).end().find(".ui-dialog-content").dialog("option", {
//	        "resizable": original.config.resizable,
	        "height": original.size.height,
	        "maxHeight": original.size.maxHeight
	      }).off('dialogclose', this._collapse_restore);

	      if (original.config.resizable) {
	    	  $(this.element[0]).dialog("widget").resizable("enable");
	      }
	    },
	    _initStyles_collapse: function() {
	      var style;

	      if (!$(".dialog-extend-collapse-css").length) {
	        style = '';
	        style += '<style class="dialog-extend-collapse-css" type="text/css">';
	        style += '.ui-dialog .ui-dialog-titlebar-collapse { width: 19px; height: 18px; }';
	        style += '.ui-dialog .ui-dialog-titlebar-collapse span { display: block; margin: 1px; }';
	        style += '.ui-dialog .ui-dialog-titlebar-collapse:hover,';
	        style += '.ui-dialog .ui-dialog-titlebar-collapse:focus { padding: 0; }';
	        style += '</style>';
	        return $(style).appendTo("body");
	      }
	    },
	    _collapse_restore: function() {
	      return $(this).dialogExtend("restore");
	    }
	  });

	}).call(this);

	(function() {
	  var $;

	  $ = jQuery;

	  $.extend(true, $.ui.dialogExtend.prototype, {
	    modes: {
	      "maximize": {
	        option: "maximizable",
	        state: "maximized"
	      }
	    },
	    options: {
	      "maximizable": false,
	      "icons": {
	        "maximize": "ui-icon-extlink"
	      },
	      "beforeMaximize": null,
	      "maximize": null
	    },
	    maximize: function() {
	      var newHeight, newWidth;

	      newHeight = $(window).height() - 11;
	      newWidth = $(window).width() - 11;
	      this._trigger("beforeMaximize");
	      if (this._state !== "normal") {
	        this._restore();
	      }
	      this._saveSnapshot();
	      if ($(this.element[0]).dialog("option", "draggable") && this.options.titlebar=="none") {
	        $(this.element[0]).dialog("widget").draggable("option", "handle", null).find(".ui-dialog-draggable-handle").css("cursor", "text").end();
	      }
	      $(this.element[0]).dialog("widget").css("position", "fixed").find(".ui-dialog-content").show().dialog("widget").find(".ui-dialog-buttonpane").show().end().find(".ui-dialog-content").dialog("option", {
//	        "resizable": false,
//	        "draggable": false,
	        "height": newHeight,
	        "width": newWidth,
	        "position": {
	          my: "left top",
	          at: "left top"
	        }
	      });
	      var original = this._loadSnapshot();

		  $(this.element[0]).dialog("widget").addClass('maximized');

	      if (original.config.draggable) {
	    	  $(this.element[0]).dialog("widget").draggable("disable").removeClass("ui-state-disabled").find(".ui-dialog-titlebar").css("cursor", "default");
	      }

	      if (original.config.resizable) {
	    	  $(this.element[0]).dialog("widget").resizable("disable").removeClass("ui-state-disabled");
	      }

	      $(this.element[0]).dialog("widget").on('drag.dialogExtend',function(e){
				e.preventDefault();
	      }).find(".ui-dialog-titlebar").css({
				"white-space": "nowrap",
				"cursor":"default"
	      });
	      this._setState("maximized");
	      this._toggleButtons();
	      return this._trigger("maximize");
	    },
	    _restore_maximized: function() {
	      var original;

	      original = this._loadSnapshot();
	      $(this.element[0]).dialog("widget").css("position", original.position.mode).find(".ui-dialog-titlebar").css("white-space", original.titlebar.wrap).end().find(".ui-dialog-content").dialog("option", {
//	        "resizable": original.config.resizable,
//	        "draggable": original.config.draggable,
	        "height": original.size.height,
	        "width": original.size.width,
	        "maxHeight": original.size.maxHeight,
	        "position": {
	          my: "left top",
	          at: "left+" + original.position.left + " top+" + original.position.top
	        }
	      }).removeClass('maximized');

	      if (original.config.draggable) {
	    	  $(this.element[0]).dialog("widget").draggable("enable").find(".ui-dialog-titlebar").css("cursor", "move");
	      }

	      if (original.config.resizable) {
	    	  $(this.element[0]).dialog("widget").resizable("enable");
	      }

	      return $(this.element[0]);
	    },
	    _initStyles_maximize: function() {
	      var style;

	      if (!$(".dialog-extend-maximize-css").length) {
	        style = '';
	        style += '<style class="dialog-extend-maximize-css" type="text/css">';
	        style += '.ui-dialog .ui-dialog-titlebar-maximize { width: 19px; height: 18px; }';
	        style += '.ui-dialog .ui-dialog-titlebar-maximize span { display: block; margin: 1px; }';
	        style += '.ui-dialog .ui-dialog-titlebar-maximize:hover,';
	        style += '.ui-dialog .ui-dialog-titlebar-maximize:focus { padding: 0; }';
	        style += '</style>';
	        return $(style).appendTo("body");
	      }
	    }
	  });

	}).call(this);

	(function() {
	  var $;

	  $ = jQuery;

		/*
			Based on the ticket "https://bugs.jqueryui.com/ticket/2804" this global jquery variable is not required.
			To disable the management associated with it, it is set to 1.
			This is because it did not allow the use of a dialog material on a dialog jquery because a global focusin 
			type listener was instanced on the whole document.
		*/
		$.ui.dialog.overlayInstances = 1;

	  $.extend(true, $.ui.dialogExtend.prototype, {
	    modes: {
	      "minimize": {
	        option: "minimizable",
	        state: "minimized"
	      }
	    },
	    options: {
	      "minimizable": false,
	      "minimizeLocation": "left",
	      "icons": {
	        "minimize": "ui-icon-minus"
	      },
	      "beforeMinimize": null,
	      "minimize": null
	    },
	    minimize: function() {

	    	var newHeight = $(this.element[0]).dialog("widget").find(".ui-dialog-titlebar").height() + 10;
	    	var newWidth = this.minimizedDialogWidth;

	    	this._trigger("beforeMinimize");
	    	this._saveSnapshot();

	    	var $minimized_elements = $('.ui-dialog.minimized');
	    	var positionLeft = isDefined($minimized_elements) ? $minimized_elements.length * newWidth : 0;

	    	var original = this._loadSnapshot();

	    	$(this.element[0]).dialog("widget").addClass('minimized').css({
	    		"width"		: newWidth,
	    		"height"	: newHeight,
	    		"left"		: positionLeft
	    	});

	    	this._repositionDialogs();
	    	if (original.config.draggable) {
		        $(this.element[0]).dialog("widget").draggable("disable").removeClass("ui-state-disabled").find(".ui-dialog-titlebar").css("cursor", "default");
	    	}

	    	if (original.config.resizable) {
		        $(this.element[0]).dialog("widget").resizable("disable").removeClass("ui-state-disabled");
	    	}

	    	this._setState("minimized");
	    	this._toggleButtons();
	    	return this._trigger("minimize");
	    },
	    _restore_minimized: function() {

	    	var element = $(this.element[0]).dialog("widget");
	        var original = this._loadSnapshot();
	        element.css({
	            "float": "none",
	            "margin": 0,
	            "position": original.position.mode
	        }).removeClass('minimized')
	        .find(".ui-dialog-content").show().dialog("option", {
//	            "resizable": original.config.resizable,
//	            "draggable": original.config.draggable,
	            "height": original.size.height,
	            "width": original.size.width,
	            "maxHeight": original.size.maxHeight,
	            "position": {
	                my: "left top",
	                at: "left+" + original.position.left + " top+" + original.position.top
	            }
	        });

	        this._repositionDialogs();
	        if (original.config.draggable) {
		        $(this.element[0]).dialog("widget").draggable("enable").find(".ui-dialog-titlebar").css("cursor", "move");
	        }

	        if (original.config.resizable) {
		        $(this.element[0]).dialog("widget").resizable("enable");
	        }

	        return element;
	    },
	    _initStyles_minimize: function() {
	      var style;

	      if (!$(".dialog-extend-minimize-css").length) {
	        style = '';
	        style += '<style class="dialog-extend-minimize-css" type="text/css">';
	        style += '.ui-dialog .ui-dialog-titlebar-minimize { width: 19px; height: 18px; }';
	        style += '.ui-dialog .ui-dialog-titlebar-minimize span { display: block; margin: 1px; }';
	        style += '.ui-dialog .ui-dialog-titlebar-minimize:hover,';
	        style += '.ui-dialog .ui-dialog-titlebar-minimize:focus { padding: 0; }';
	        style += '</style>';
	        return $(style).appendTo("body");
	      }
	    },
	    _verifyOptions_minimize: function() {
	      var _ref;

	      if (!this.options.minimizeLocation || ((_ref = this.options.minimizeLocation) !== 'left' && _ref !== 'right')) {
	        $.error("jQuery.dialogExtend Error : Invalid <minimizeLocation> value '" + this.options.minimizeLocation + "'");
	        return this.options.minimizeLocation = "left";
	      }
	    },
	    _minimize_removeOverlay: function() {
	      $(this).dialogExtend("restore");
	      $(this).dialog("widget").appendTo($('body'));
	      $(this).data("dialog-extend-minimize-overlay").remove();
	      return $(this).removeData("dialog-extend-overlay");
	    }
	  });

	}).call(this);

	function getDshPagesByCustomJsId(customJsId){
		var openDialogs = getJqDialogDataFromBody();
		var pages = [];
		for (var i in openDialogs) {
			var winRef = openDialogs[i].objWin,
					dshPageElement = winRef.DSH_PAGE ? winRef.DSH_PAGE.getDshElementFromCustomJsId(customJsId, '121', true) : null;
			if(isValidObject(dshPageElement)){
				pages.push(winRef.DSH_PAGE.api());
			}
		}
		return pages;
	}